import {
    FileText, Phone, Mail, Home, DollarSign,
    Calendar, Bell, TrendingUp
} from 'lucide-react';

export const mockActivities = [
    {
        id: 1,
        type: 'property_created',
        icon: FileText,
        iconColor: 'text-blue-600',
        bgColor: 'bg-blue-50',
        text: 'Publicaste nueva propiedad: Casa en Escalón',
        time: 'Hace 2h'
    },
    {
        id: 2,
        type: 'call_made',
        icon: Phone,
        iconColor: 'text-green-600',
        bgColor: 'bg-green-50',
        text: 'Llamaste a lead: María García',
        time: 'Hace 5h'
    },
    {
        id: 3,
        type: 'email_sent',
        icon: Mail,
        iconColor: 'text-purple-600',
        bgColor: 'bg-purple-50',
        text: 'Enviaste propuesta a: Carlos Méndez',
        time: 'Ayer'
    },
    {
        id: 4,
        type: 'property_updated',
        icon: Home,
        iconColor: 'text-orange-600',
        bgColor: 'bg-orange-50',
        text: 'Actualizaste propiedad: Apartamento Santa Elena',
        time: 'Hace 2 días'
    },
    {
        id: 5,
        type: 'deal_closed',
        icon: DollarSign,
        iconColor: 'text-green-600',
        bgColor: 'bg-green-50',
        text: 'Cerraste venta: $250,000',
        time: 'Hace 3 días'
    },
    {
        id: 6,
        type: 'appointment_scheduled',
        icon: Calendar,
        iconColor: 'text-blue-600',
        bgColor: 'bg-blue-50',
        text: 'Agendaste cita con: Luis Ramírez',
        time: 'Hace 4 días'
    },
    {
        id: 7,
        type: 'lead_received',
        icon: Bell,
        iconColor: 'text-yellow-600',
        bgColor: 'bg-yellow-50',
        text: 'Recibiste nuevo lead de formulario web',
        time: 'Hace 1 semana'
    },
    {
        id: 8,
        type: 'metric_improved',
        icon: TrendingUp,
        iconColor: 'text-green-600',
        bgColor: 'bg-green-50',
        text: 'Tu tiempo respuesta mejoró 5m esta semana',
        time: 'Hace 1 semana'
    }
];
